import request from '@/http/request'

export const getRfidDailyReport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/nfc-email/api/report/getRfidDailyReport`, params)
}

export const getByCartonReport = () => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/nfc-email/api/report/getRfidDailyReport/byCarton`)
}

export const getScanInfoReport = (type, params) => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/nfc-email/api/report/getRfidDailyReport/scanInfo/${type}`,
    params
  )
}

export const getTunnelReport = (type, params) => {
  return request.post(
    `${process.env.REACT_APP_RFID_API_URL}/nfc-email/api/report/getRfidDailyReport/tunnel/${type}`,
    params
  )
}

export const rfidDailyReportExport = params => {
  return request.post(`${process.env.REACT_APP_RFID_API_URL}/nfc-email/api/report/dailyReport/export`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}

export const rfidAbnormalReport = (type, params) => {
  return request.post(`${process.env.REACT_APP_API_URL}/nfc-email/api/report/abnormalReport/export/${type}`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
